var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.117,
    height: 14.117,
    viewBox: "0 0 14.117 14.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e02a58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be0031"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2193",
    "data-name": "Trazado 2193",
    d: "M-7987.951,257.076a5.594,5.594,0,0,0-.552,2.068h13.125a5.614,5.614,0,0,0-.552-2.068c-.331-.662-1.71-1.186-3.446-1.82-.331-.111-.661-.22-.992-.359a.23.23,0,0,1-.166-.22v-1.792a.244.244,0,0,1,.082-.166,2.471,2.471,0,0,0,.662-1.682.214.214,0,0,1,.193-.221,1.173,1.173,0,0,0,.138-.662.473.473,0,0,0-.221-.386.252.252,0,0,1-.11-.22,1.33,1.33,0,0,1,.139-.441,4.683,4.683,0,0,0,.44-2.178c-.109-.634-1.269-.965-2.316-.965-1.02,0-1.875.3-1.957.69a.28.28,0,0,1-.248.165.643.643,0,0,0-.579.248c-.358.469,0,1.627.139,2.123a.919.919,0,0,1,.082.359.252.252,0,0,1-.11.22.473.473,0,0,0-.221.386,1.164,1.164,0,0,0,.138.662.213.213,0,0,1,.193.221,1.967,1.967,0,0,0,.661,1.572.212.212,0,0,1,.083.192v1.875a.231.231,0,0,1-.166.22c-.33.139-.66.248-.991.359C-7986.242,255.891-7987.62,256.414-7987.951,257.076Zm-.8,2.536a.247.247,0,0,1-.248-.248,6.3,6.3,0,0,1,.606-2.51c.441-.827,1.82-1.323,3.723-2.04.275-.083.551-.193.854-.3v-1.627a2.329,2.329,0,0,1-.717-1.682.969.969,0,0,1-.3-.579,1.211,1.211,0,0,1,.248-1.186,1.181,1.181,0,0,1-.027-.138c-.193-.634-.579-1.847-.082-2.537a1.192,1.192,0,0,1,.8-.413c.331-.634,1.462-.855,2.371-.855,1.241,0,2.593.413,2.785,1.351a4.85,4.85,0,0,1-.469,2.426c-.027.055-.056.138-.083.193a1.158,1.158,0,0,1,.249,1.158.969.969,0,0,1-.3.579,2.806,2.806,0,0,1-.717,1.792v1.517c.3.11.579.22.854.3,1.9.717,3.281,1.214,3.723,2.04a6.3,6.3,0,0,1,.606,2.51.247.247,0,0,1-.248.248Z",
    transform: "translate(7988.999 -245.495)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/AccountIcon.d276687dcf47d0701309707967fc383b.svg";
export { ForwardRef as ReactComponent };